module.exports = __webpack_public_path__ + "img/medal9.d9078800.png";